import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum Audience {
    "Internal" = 0,   
    "Beneficiary" = 1,
    "Sponsor" = 2,
    "Relative" = 3,
}

export const AudienceList: EnumOption[] = createEnumOptions(Audience);
